export default {
    GLOBAL_PAYMENTS: '9ad90aca-0243-417c-a286-8b7a9aafe7ac',
    AXIAMED: 'f722b17a-4bfd-4c59-a1e3-57ffa5b110c4',
    GLOBAL_PAYMENTS_GENIUS: '2e536f3b-2571-4266-8de0-64c2dd6b22e8',
    FISERV_CARDPOINTE: '58fabe9a-aaa1-40a1-aa5a-28db9dd40739',
    TRUST_COMMERCE: 'bf425506-18bb-40d2-868a-f5b94517e3e8',
    JPMC_INSTAMED: '7a5a6e0c-590f-47e8-a3f5-92e2a085b84a',
};



// WEBPACK FOOTER //
// ./src/components/common/payment-gateways.js